import { toggleConfirmDialog } from "../../store/slice/dialogSlice";
import { useDispatch, useSelector } from "react-redux";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider } from "@mui/material";
import React, { useState } from "react";
import { MultilineTextBox } from "../TextBox";
import Box from "@mui/material/Box";
import { usePostChangeComparisonStatusMutation, usePostCreateOrderFromBidsMutation } from "../../store/api/bidComparsion";
import { showErrorToast, showSuccessToast } from "../../constToast/constToast";
import { useNavigate } from "react-router-dom";
import moment from "moment";

const ConfirmDialog = ({ refetch, businessUnitId }) => {
    const dispatch = useDispatch()
    const open = useSelector((state) => state.dialogSlice.confirmDialog)
    const [comment, setComment] = useState('')
    const [postData] = usePostChangeComparisonStatusMutation()
    const [postCreateOrder] = usePostCreateOrderFromBidsMutation()
    const selectedLines = useSelector((state) => state.bidComparsionSlice.selectedLines)
    const chartData = useSelector((state) => state.bidComparsionSlice.comparsionChartData)
    const selectedSequenceFromWFA = useSelector((state) => state.bidComparsionSlice.selectedSequenceFromWFA)
    const navigate = useNavigate()

    const handleClose = () => {
        dispatch(toggleConfirmDialog())
        setComment('')
    }

    const handleSubmit = async () => {
        const res = await postData(Object.values(selectedLines)?.map(item => {
            return {
                ...item,
                comment: item?.comment || comment,
                businessUnitId: businessUnitId
            }
        }))
        if (res?.data?.statusCode == 200) {
            let maxSequence = null;
            for (const item of chartData?.approvalInformations) {
                const sequence = item.sequence;
                if (maxSequence === null || sequence > maxSequence) {
                    maxSequence = sequence;
                }
            }
            if (maxSequence === selectedSequenceFromWFA && moment(chartData?.bidComparisonHeader?.comparisondeadline).isAfter(moment(new Date()))) {
                const bidMainIdList = []
                Object.values(selectedLines).filter(item => item.sequence === selectedSequenceFromWFA).forEach(x => {
                    if (!bidMainIdList.includes(x.bidMainId)) {
                        bidMainIdList.push(x.bidMainId)
                    }
                })
                await postCreateOrder({ bidMainIdList })
            }
            refetch && refetch()
            showSuccessToast('Successfully')
            navigate('/bid-comparison')
        } else {
            showErrorToast('Error')
        }
        setComment('')
        handleClose()
    }

    return (
        <Dialog open={open} onClose={handleClose} fullWidth>
            <DialogTitle>Confirm Decisions</DialogTitle>
            <Divider />
            <DialogContent>
                <Box sx={{ mt: 2 }}>
                    <MultilineTextBox label="Comment" value={comment} setValue={setComment} rows="4" />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button
                    variant="contained"
                    onClick={handleSubmit}
                >
                    Confirm
                </Button>
                <Button variant="outlined" onClick={handleClose} sx={{ color: 'gray', borderColor: '#D3D3D3' }}>
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default ConfirmDialog